export const SET_DASHBOARD_DATA="SET_DASHBOARD_DATA"
export const RELOAD_DASHBOARD_DATA="RELOAD_DASHBOARD_DATA"